// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "patientDashboard." + ({"138":"profile","147":"app-routes","251":"checkout","352":"onboarding"}[chunkId] || chunkId) + "." + {"138":"3f6cf76d028caf71a25a","147":"a368a9b7a4ea5b5d1e6c","251":"5b1957a4e3e12df5c851","352":"cf0edbc8cfa402b92cec","550":"b011e4abbc8967a4f77d"}[chunkId] + ".js";
};